module.exports = global["Phaser"] = require("-!./phaser-split.js");


//////////////////
// WEBPACK FOOTER
// ./~/phaser/build/custom/phaser-split.js
// module id = 1
// module chunks = 0